export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Ver tudo',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Confira-os!',
  'topicsToDiscuss': 'Tópicos para Discussão',
  'OneOnOneMeet': 'Encontro 1:1',
  'learnMoreNetworking': 'Saiba mais sobre o Networking Hub',
  'scanQrCode': 'Escanear QR Code',
  'myBadge': 'Meu Badge',
  'message': 'Mensagem',
  'scannedBadge': 'Badge Escaneado',
  'viewProfile': 'Ver Perfil',
  'userRatingDetails': 'Detalhes da Avaliação do Usuário',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Pontuação total:',
  'scoreComposedOf': 'Esta pontuação é composta por:',
  'confirmationText': 'Você tem certeza? Isso não pode ser desfeito.',

  'welcomeMessage': 'Bem-vindo ao <strong>Networking Hub</strong>, onde as conexões ganham vida! Veja como funciona:',
  'connectingMadeSimpleTitle': 'Conexões Simples',
  'connectingMadeSimpleDescription':
    'O Networking Hub oferece atividades estruturadas e níveis para ajudar você a se conectar de forma eficaz:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Explore perfis de novatos, adicione os interessantes à sua lista e envie mensagens. Você também pode se conectar com eles pessoalmente.',
  'shortlistDescription':
    '<strong>Shortlist:</strong> Uma vez que você mostra interesse em alguém, a pessoa é adicionada à sua lista.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Quando você entra em contato e recebe uma resposta, a pessoa vai para essas categorias.',
  'skipDescription': '<strong>Skip:</strong> Não está interessado? Basta pular o perfil e seguir em frente!',

  'enhancedNetworkingActivitiesTitle': 'Atividades de Networking Aprimoradas',
  'enhancedNetworkingActivitiesDescription': 'Além das conexões diretas, o Hub inclui:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Explore tópicos que lhe interessam e se conecte com autores ou participantes. Participe de discussões online ou agende reuniões em grupo para aprofundar esses tópicos.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Gerencie solicitações de reunião, acompanhe as reuniões agendadas e organize sua agenda com facilidade.',

  'gamificationTitle': 'Gamificação para Diversão e Engajamento',
  'gamificationDescription':
    'Aumente sua atividade com um leaderboard que rastreia seus pontos e mostra os networkers mais ativos. Veja como você pode ganhar pontos:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 pontos:</strong> Complete seu perfil (incluindo uma foto).',
    points1000PushNotifications: '<strong>1.000 pontos:</strong> Ative as notificações push.',
    points100SendMeetingRequest: '<strong>100 pontos:</strong> Envie uma solicitação de reunião 1:1.',
    points400GetAcceptedRequest: '<strong>400 pontos:</strong> Faça sua solicitação de reunião 1:1 ser aceita.',
    points400AcceptRequest: '<strong>400 pontos:</strong> Aceite uma solicitação de reunião 1:1.',
    points100DeclineRequest: '<strong>100 pontos:</strong> Recuse uma solicitação de reunião 1:1.',
    points400CreateDiscussion: '<strong>400 pontos:</strong> Crie um tópico de discussão.',
    points50LikeDiscussion: '<strong>50 pontos:</strong> Curta um tópico de discussão.',
    points200PostFirstComment: '<strong>200 pontos:</strong> Sempre que você postar seu primeiro comentário em outro tópico.',
    points100LikeOnTopic: '<strong>100 pontos:</strong> Ganhe um like em seu tópico.',
    points200UniqueCommenter: '<strong>200 pontos:</strong> Ganhe um comentarista único em seu tópico.',
    points100LikeShortlistUser: '<strong>100 pontos:</strong> Curta/adicione um usuário à sua lista.',
    points50SkipUser: '<strong>50 pontos:</strong> Pule um usuário.',
    points200StartChat: '<strong>200 pontos:</strong> Comece uma conversa (contatado).',
    points300GetChatResponse: '<strong>300 pontos:</strong> Receba uma resposta no chat (conectado).',
    points400RespondToChat: '<strong>400 pontos:</strong> Responda a uma solicitação de chat (conectado).',
    points500SpeedNetworking: '<strong>500 pontos:</strong> Para cada sessão de networking rápido.'
  },

  'finalMessage':
    'Aproveite ao máximo o Networking Hub, descubra novas oportunidades e suba na classificação à medida que se conecta e interage com profissionais de mentalidade semelhante!',

  'manageMeeting': 'Gerenciar reunião',
  'addToCalendar': 'Adicionar ao calendário',
  'cancel': 'Cancelar',
  'accept': 'Aceitar',
  'accept&addToCalendar': 'Aceitar e adicionar ao calendário',
  'editDetails': 'Editar detalhes',
  'reject': 'Rejeitar',
  'delete': 'Excluir',
  'exportContact': 'Exportar contato',
  'scheduleNewOneOnOne': 'Agendar novo 1:1',
  'initiatedBy': 'Iniciado por',
  'rejectedBy': 'Rejeitado por',
  'you': 'você',
  'meetPassed': 'A reunião já passou',
  'meetInProgress': 'Em andamento',

  'myOneOnOne': 'Meu 1:1',

  'speed': {
    history: 'Histórico',
    minutes: 'minutos',
    users_available: 'disponíveis',
    rules: 'Regras',
    activate: 'Ativar',
    matching: 'Emparelhando...',
    start: 'Começar',
    find_a_user: 'Encontre um usuário com a mesma imagem',
    find_a_user_number: 'Encontre um usuário com o mesmo número',
    waiting: 'Aguardando...',
    speaking_now: 'Falando agora',
    networking_topics: 'Tópicos de networking',
    session_ended: 'Sessão encerrada',
    find_next_partner: 'Encontrar próximo parceiro',
    find_next_group: 'Encontrar próximo grupo',
    partner_wasnt_ready: 'Parceiro não estava pronto',
    partner_wasnt_ready_description: 'Parece que o parceiro não estava pronto para a conversa. Vamos encontrar outro!',
    start_matching: 'Começar emparelhamento'
  }
}
